import { Route } from 'react-router';

export const PrivateRoute = ({ type, component: Component, ...rest }) => {
	return (
		<Route 
			{...rest}
			render={(props) => {
				if (type) {
					return <Component {...props} />;
				} else {
					window.location.href = '/Account/Login';
					return null;
				}
			}}
		/>
	)
};